module.exports = __webpack_public_path__ + "static/img/banner_02.8fd7b417.png";